import React, { type ReactElement, type Ref } from 'react';
import Image from 'next/image';
import {
  Swiper,
  SwiperSlide,
  type SwiperProps,
  type SwiperRef,
} from 'swiper/react';
import 'swiper/css';
import classNames from 'classnames';

import { type ImageType } from '@/common/types/image.type';

export interface CarouselSlidesProps extends SwiperProps {
  carouselRef: Ref<SwiperRef>;
  images: ImageType[];
  activeIndex: number;
  onIndexChange: (index: number) => void;
}

export default function CarouselSlides({
  carouselRef,
  images,
  activeIndex,
  onIndexChange,
  ...rest
}: CarouselSlidesProps): ReactElement {
  const handleImageClick = (index: number) => {
    onIndexChange(index);
  };

  return (
    <Swiper
      slidesPerView={4}
      centeredSlides={true}
      spaceBetween={12}
      ref={carouselRef}
      className="mySwiper cursor-pointer"
      {...rest}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <div
            className={classNames(
              'relative h-[96px] w-[88px] rounded-md bg-silver-100',
              {
                'border border-secondary-200': index === activeIndex,
              }
            )}
            onClick={() => {
              handleImageClick(index);
            }}
          >
            <Image
              src={image.url || ''}
              alt={image.name || ''}
              fill
              objectFit="contain"
              loading="lazy"
              sizes="88px"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
